import React, {memo, useEffect} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useHistory} from 'react-router-dom';

export const LoginContent = memo(function LoginContent() {
    const history = useHistory();

    useEffect(() => {
        history.push('/settings');
    });

    return <></>;
});


export function SettingsLoginScreen() {
    return (
        <PasswordContainer requiredRole='user'>
            <LoginContent/>
        </PasswordContainer>
    );
}
